import {
    ProviderType,
    IntegrationDefinition
} from './types.ts';
import {Github, Gitlab, Slack, Mail, MessageSquare, Smartphone} from 'lucide-react';

export const PROVIDER_ICONS: Record<string, any> = {
    [ProviderType.GITHUB]: Github,
    [ProviderType.GITLAB]: Gitlab,
    [ProviderType.SLACK]: Slack,
    [ProviderType.TEAMS]: MessageSquare,
    [ProviderType.EMAIL]: Mail,
    [ProviderType.SMS]: Smartphone,
};

export const AVAILABLE_INTEGRATIONS: IntegrationDefinition[] = [
    {
        provider: ProviderType.GITHUB,
        name: 'GitHub Enterprise',
        description: 'Trigger notifications from Pull Requests, Issues, and Pushes in your GitHub repositories.',
        features: ['Real-time webhook events', 'PR review tracking', 'Label filtering', 'CI/CD status updates']
    },
    {
        provider: ProviderType.GITLAB,
        name: 'GitLab',
        description: 'Connect your GitLab projects to automate workflows based on Merge Requests and pipelines.',
        features: ['Merge Request events', 'Pipeline notifications', 'Group-level integration']
    },
    {
        provider: ProviderType.SLACK,
        name: 'Slack',
        description: 'Send formatted alerts to Slack channels or direct messages when important events occur.',
        features: ['Rich text formatting', 'Thread updates', 'Interactive buttons', 'Channel discovery']
    },
    {
        provider: ProviderType.TEAMS,
        name: 'Microsoft Teams',
        description: 'Post Adaptive Cards to Microsoft Teams channels for seamless enterprise communication.',
        features: ['Adaptive Cards', 'Channel notifications', 'Mention support']
    },
    {
        provider: ProviderType.EMAIL,
        name: 'Email / SMTP',
        description: 'Send classic email notifications to distribution lists or specific stakeholders.',
        features: ['Custom SMTP support', 'HTML templates', 'Attachment support']
    },
];
